import React from 'react';
import './App.css';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Backdrop, CircularProgress, Snackbar, IconButton, Slide } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import Dash from './components/Dash';
import Api from './Api'
import Login from './components/Login';
import { Alert } from '@material-ui/lab'
const SlideTransition = React.forwardRef(
  (props, ref) => (
    <Slide
      {...props} ref={ref}
      direction="up"
    />
  )
)

function App() {
  const [loading, setLoading] = React.useState(false)
  const [snackbar, setSnackBar] = React.useState({
    type: 'snack',
    message: 'Hello',
    show: false,
    duration: 4000
  })
  const api = new Api(setLoading, setSnackBar);
  const handleClose = () => {
    setSnackBar({ type: 'snack', message: '', show: false, duration: 6000 })
  }


  return (
    <div>
      <Snackbar
        style={{ zIndex: 10010 }}
        TransitionComponent={SlideTransition}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }} message={snackbar.message} action={
          <div>
            {
              snackbar.type === 'snack' ? null :
                <IconButton aria-label="close"
                  color="inherit"
                  onClick={handleClose}>
                  <Close />
                </IconButton>
            }

          </div>
        } open={snackbar.show} autoHideDuration={snackbar.duration} onClose={handleClose}>
        {snackbar.type !== 'snack' && <Alert onClose={handleClose} severity={snackbar.type}>{snackbar.message}</Alert>}
      </Snackbar>

      <Backdrop style={{ zIndex: 9999 }} open={loading} >
        <CircularProgress style={{ color: '#fff' }} />
      </Backdrop>
      <BrowserRouter>
        <Switch>
          <Route path="/" exact>
            <Redirect to="/dash" />
          </Route>
          <Route path="/login">
            <Login api={api} />
          </Route>
          <Route path="/dash" >
            <Dash api={api} />
          </Route>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
